module.exports = __webpack_public_path__ + "img/maison-3.f6b721f9.png";